import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {ProgressIndicator, Table} from '@sabre/spark-react'
import LoadingIconButton from 'shared/components/LoadingIconButton/index'
import moment from 'moment'
import config from 'config/applicationConfig'

export default class BriefingTable extends PureComponent {

    loadingMessage = 'Loading briefing data ...'
    tableNoDataText = 'No briefing data found.'
    titleDisplay = 'Display'
    columnHeaderFile = 'File'
    columnHeaderActions = ''
    columnHeaderProduct = 'Product'
    columnHeaderSubProduct = 'SubProduct'
    columnHeaderCreateDate = 'Create date'
    columnHeaderCreatorName = 'Creator name'

    getFileIcon(type) {
        switch (type) {
            case 'image/jpeg':
            case 'image/jpg':
            case 'image/png':
            case 'image/tiff':
            case 'image/svg+xml':
                return 'picture'
            case 'application/pdf':
            case 'application/octet-stream':
            case 'application/x-zip-compressed':
                return 'document'
            case 'text/plain':
            case 'text/xml':
                return 'document-font'
            default:
                return 'question-mark-circle'
        }
    }

    getAllIds() {
        return this.props.data.map(val => val.id)
    }

    isLoading(id) {
        return this.props.loadingIds !== undefined && this.props.loadingIds.indexOf(id) !== -1
    }

    isSelected(id) {
        return this.props.selectedIds !== undefined && this.props.selectedIds.indexOf(id) !== -1
    }

    isSelectedAll() {
        return this.props.selectedIds !== undefined && this.props.data.length > 0 &&
            this.props.selectedIds.length === this.props.data.length
    }

    onSelect(id, event) {
        this.props.actions.onSelectDocument({id: id, checked: event.target.checked})
    }

    onSelectAll(event) {
        this.props.actions.onSelectAllDocuments({ids: this.getAllIds(), checked: event.target.checked})
    }

    colSelect() {
        return {
            Header: props => (
                <label className='spark-checkbox--sm'>
                    <input className='spark-checkbox__box' type='checkbox'
                           onChange={(event) => this.onSelectAll(event)} checked={this.isSelectedAll()}/>
                </label>
            ),
            Cell: props => (
                <label className='spark-checkbox--sm'>
                    <input className='spark-checkbox__box' type='checkbox'
                           onChange={(event) => this.onSelect(props.original.id, event)}
                           checked={this.isSelected(props.original.id)}/>
                </label>
            ),
            resizable: false,
            sortable: false,
            width: 48,
            className: 'spark-text-center'
        }
    }

    colFile() {
        return {
            Header: this.columnHeaderFile,
            Cell: props => (
                <div className={`colFile spark-icon-${this.getFileIcon(props.original.mime_type)}`}/>
            ),
            resizable: false,
            sortable: false,
            width: 148,
            className: 'spark-text-center'
        }
    }

    colActions() {
        return {
            Header: this.columnHeaderActions,
            Cell: props => (
                <nav>
                    <div>
                        <LoadingIconButton
                            onClick={() => this.props.actions.onDisplayProduct({
                                productId: props.original.id,
                                format: props.original.Formats[0]
                            })}
                            icon='spark-icon-search'
                            loading={this.isLoading(props.original.id)}
                            title={this.titleDisplay}/>
                    </div>
                </nav>
            ),
            resizable: false,
            sortable: false,
            width: 148,
            className: 'spark-text-right'
        }
    }

    colDefault(header, accessor, visible = true) {
        return {
            Header: header,
            accessor: accessor,
            className: 'spark-text-center',
            show: visible,
            sortable: true
        }
    }

    colDateTime(header, accessor, visible = true) {
        return {
            Cell: row => (
                <span>{moment(row.value).utc().format(config.dateTimeDisplayFormat)}</span>
            ),
            Header: header,
            accessor: accessor,
            className: 'spark-text-center',
            show: visible,
            sortable: true
        }
    }

    render() {
        const columns = [
            this.colSelect(),
            this.colFile(),
            this.colDefault(this.columnHeaderProduct, 'Type.extension'),
            this.colDefault(this.columnHeaderSubProduct, 'Subname'),
            this.colDateTime(this.columnHeaderCreateDate, 'Created'),
            this.colDefault(this.columnHeaderCreatorName, 'Creator'),
            this.colActions()
        ]

        return (
            <React.Fragment>
                <section className="spark-table">
                    {this.props.data !== undefined &&
                    <Table data={this.props.data}
                           className="condensed empty-table" columns={columns} noDataText={this.tableNoDataText}
                           defaultSorted={[{id: 'Created', desc: true}]}
                    />}
                </section>
                {this.props.isLoading &&
                <div className="col-xs-12 progress-container">
                    <ProgressIndicator msg={this.loadingMessage} size="sm"/>
                </div>}
            </React.Fragment>
        )
    }
}

BriefingTable.propTypes = {
    data: PropTypes.array,
    selectedIds: PropTypes.array,
    actions: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    loadingIds: PropTypes.array
}


// WEBPACK FOOTER //
// ./src/screens/briefing/products/components/BriefingTable.js